<template>
  <div>
    <div class="container-buttons">
      <ButtonMedium
        v-if="allows_crud && !rubric"
        :tooltip_text="``"
        :text_button="
          $t('reusable.common.addTooltip', {
            entity: $getVisibleNames('evaluations2.rubric', false, 'Pauta'),
          })
        "
        :click_button="
          () =>
            $bvModal.show(
              `modal-create-rubric-${instrument_id}-${container_instrument_id}`
            )
        "
        :icon="'plus'"
        :variant="'primary'"
        :custom_class="`mb-2 mt-4 ml-2`"
      >
      </ButtonMedium>
      <!-- <b-button
        v-if="allows_crud && !rubric"
        size="sm"
        variant="primary"
        class="mb-2 mt-4 ml-2"
        @click="
          $bvModal.show(
            `modal-create-rubric-${instrument_id}-${container_instrument_id}`
          )
        "
        >+ Agregar
        {{ $getVisibleNames("evaluations2.rubric", false, "Pauta") }}</b-button
      > -->
    </div>
    <div
      class="d-flex justify-content-left mb-2 mr-2 noprint"
      v-if="rubric && !evaluatee_view && !evaluator_view && !preview_evaluation"
    >
      <ButtonMedium
        :tooltip_text="``"
        :text_button="$t('evaluations.newEvaluations.specificationTable')"
        :click_button="
          () =>
            $bvModal.show(
              `modal-specification-table-rubric-${test.id}-${container_instrument_id}-${rubric.id}`
            )
        "
        :icon="'card'"
        :variant="'primary'"
        :custom_class="``"
      >
      </ButtonMedium>
      <!-- <b-button
        variant="primary"
        size="sm"
        class="noprint"
        @click="
          $bvModal.show(
            `modal-specification-table-rubric-${test.id}-${container_instrument_id}-${rubric.id}`
          )
        "
      >
        <div class="d-flex align-items-center">
          <b-icon icon="card-list" class="mr-1"></b-icon>
          <span>Tabla de Especificaciones</span>
        </div>
      </b-button> -->
      <b-modal
        :id="`modal-specification-table-rubric-${test.id}-${container_instrument_id}-${rubric.id}`"
        :title="$t('evaluations.newEvaluations.specificationTable')"
        hide-footer
        size="xl"
      >
        <NewSpecificationTable
          :allows_crud="allows_crud"
          :test="test"
          :observation_table="true"
          :rubric_id="rubric.id"
          :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
        ></NewSpecificationTable>
      </b-modal>
    </div>
    <HeaderRubric
      v-if="rubric && filter_rubric_instance == null"
      :container_instrument_id="container_instrument_id"
      :instrument_id="instrument_id"
      :preview_evaluation="preview_evaluation"
      :rubric_id="rubric.id"
      :allows_crud="allows_crud"
      @reset_rubric_coevaluators="() => key_coevaluator_rubric++"
    ></HeaderRubric>
    <b-table
      v-if="rubric && filter_rubric_instance == null"
      :fields="fields"
      :items="rubricAchievementList"
      small
      caption-top
      bordered
      show-empty
      :empty-text="$t('evaluations.newEvaluations.noAchievementLevelsToShow')"
    >
      <template #cell(description)="row">
        <div>
          <RenderVHtml :content="row.item.description"></RenderVHtml>
        </div>
      </template>
    </b-table>
    <CoEvaluatorRubric
      v-if="
        test &&
        test.evaluatees.length > 1 &&
        rubric &&
        evaluative_agent &&
        (['duoc_coevaluacion_evaluative_agent'].includes(
          evaluative_agent.internal_use_id
        ) ||
          $equals(evaluative_agent.name, 'Coevaluación'))
      "
      :key="key_coevaluator_rubric"
      :rubric="rubric"
      :test="test"
      :user_id="user_id"
      :allows_crud="allows_crud"
      :evaluatee_view="evaluatee_view"
      :is_running_test="is_running_test"
      :finished_test="finished_test"
      :evaluator_view="evaluator_view"
    ></CoEvaluatorRubric>
    <SelectedCoevaluatorRubric
      v-if="
        rubric &&
        ((((is_running_test && !finished_test) ||
          (!is_running_test && finished_test)) &&
          evaluatee_view) ||
          evaluator_view)
      "
      :rubric="rubric"
      :test="test"
      :user_id="user_id"
      :allows_crud="allows_crud"
      :evaluatee_view="evaluatee_view"
      :is_running_test="is_running_test"
      :finished_test="finished_test"
      :evaluator_view="evaluator_view"
      @student_selcted="slotStudentSelected"
    >
    </SelectedCoevaluatorRubric>
    <!-- <div>user_id:{{ user_id }}</div>
    <div>coevaluator_id:{{ coevaluator_id }}</div>
    <div>currentUserId:{{ currentUserId }}</div>
    <div>currentCoevaluatorId:{{ currentCoevaluatorId }}</div> -->
    <!-- Boton para Ocultar columnas -->
    <div
      v-if="evaluator_view && filter_rubric_instance == null"
      class="text-right mb-2"
    >
      <b-button
        variant="primary"
        size="sm"
        :id="`display-columns-rubric-${test.id}`"
        class="noprint"
        >{{ $t("evaluations.newEvaluations.hideColumns") }}
      </b-button>
    </div>
    <b-popover
      v-if="evaluator_view && filter_rubric_instance == null"
      :target="`display-columns-rubric-${test.id}`"
      triggers="click blur"
    >
      <div>
        <div class="text-left noprint">
          <b-form-checkbox
            :id="`column-check-1`"
            name="checkbox-1"
            v-model="hide_number"
            @change="updateCheckbox('hide_number', hide_number)"
          >
            {{ $t("evaluations.newEvaluations.number") }}
          </b-form-checkbox>
        </div>
        <div class="text-left noprint">
          <b-form-checkbox
            :id="`column-check-2`"
            name="checkbox-2"
            v-model="hide_dimension"
            @change="updateCheckbox('hide_dimension', hide_dimension)"
          >
            {{ $getVisibleNames("manual.dimension", true, "Dimensiones") }}
          </b-form-checkbox>
        </div>
        <div class="text-left noprint">
          <b-form-checkbox
            :id="`column-check-3`"
            name="checkbox-3"
            v-model="hide_weighing"
            @change="updateCheckbox('hide_weighing', hide_weighing)"
          >
            {{ $t("evaluations.newEvaluations.weighting") }}
          </b-form-checkbox>
        </div>
        <div
          v-if="institution && institution.internal_use_id != 'duoc.cl'"
          class="text-left noprint"
        >
          <b-form-checkbox
            id="column-check-4"
            name="checkbox-4"
            v-model="hide_evaluation_criteria"
            @change="
              updateCheckbox(
                'hide_evaluation_criteria',
                hide_evaluation_criteria
              )
            "
          >
            {{
              $getVisibleNames(
                "teaching.evaluationcriteriamicro",
                false,
                "Criterio de Evaluación Micro"
              )
            }}
          </b-form-checkbox>
        </div>
      </div>
    </b-popover>
    <div
      :class="{
        'rubric-achievement-overflow': rubricAchievementList.length > 5,
      }"
    >
      <table v-if="rubric">
        <thead>
          <!-- Titulo Niveles de logro -->
          <tr>
            <!-- :colspan="
                evaluation &&
                (evaluation.matter_evaluation != null ||
                  evaluation.egress_profile_matter_evaluation != null ||
                  (evaluation.parent_evaluation != null &&
                    evaluation_criteria_micro_ids.length > 0)) &&
                institution &&
                institution.internal_use_id != 'duoc.cl'
                  ? 3
                  : 2
              " -->
            <th
              :class="{
                'd-none':
                  (institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    hide_dimension == true &&
                    hide_number == true &&
                    evaluator_view) ||
                  (institution &&
                    institution.internal_use_id != 'duoc.cl' &&
                    hide_dimension == true &&
                    hide_number == true &&
                    hide_evaluation_criteria == true &&
                    evaluator_view),
              }"
              :colspan="colspanRubric"
            ></th>
            <th
              :colspan="
                rubricAchievementList.length > 0
                  ? rubricAchievementList.length
                  : 1
              "
            >
              {{
                $getVisibleNames(
                  "evaluations2.rubricperformancelevel",
                  true,
                  "Niveles de Logro"
                ).toUpperCase()
              }}
              <ButtonSmall
                v-if="allows_crud && !rubric.is_locked"
                :tooltip_text="
                  $t('reusable.common.createTooltip', {
                    entity: $getVisibleNames(
                      'evaluations2.rubricperformancelevel',
                      false,
                      'Niveles de Logro'
                    ),
                  })
                "
                :click_button="
                  () =>
                    $bvModal.show(
                      `modal-create-rubric-achievement-${instrument_id}-${container_instrument_id}`
                    )
                "
                :custom_class="`add-button`"
                :icon="'plus'"
              ></ButtonSmall>
            </th>
            <th
              :colspan="!rubric.is_locked ? 2 : 1"
              :class="{ 'd-none': hide_weighing == true && evaluator_view }"
            ></th>
          </tr>
          <tr>
            <!-- N° -->
            <th
              style="width: 1%"
              :class="{ 'd-none': hide_number == true && evaluator_view }"
            >
              N°
            </th>
            <!-- Dimensiones -->
            <th
              style="width: 15%"
              :class="{ 'd-none': hide_dimension == true && evaluator_view }"
            >
              {{
                $getVisibleNames(
                  "manual.dimension",
                  true,
                  "Dimensión"
                ).toUpperCase()
              }}
              <ButtonSmall
                v-if="allows_crud && !rubric.is_locked"
                :tooltip_text="
                  $t('reusable.common.createTooltip', {
                    entity: $getVisibleNames(
                      'manual.dimension',
                      false,
                      'Dimensión'
                    ),
                  })
                "
                :click_button="openModalDimensionCreate"
                :custom_class="`add-button`"
                :icon="'plus'"
              ></ButtonSmall>
            </th>
            <th
              v-if="
                evaluation &&
                (evaluation.matter_evaluation != null ||
                  evaluation.egress_profile_matter_evaluation != null ||
                  (evaluation.parent_evaluation != null &&
                    evaluation_criteria_micro_ids.length >= 0) ||
                  evaluation_criteria_micro_ids.length > 0) &&
                institution &&
                institution.internal_use_id != 'duoc.cl'
              "
              style="width: 15%"
              :class="{
                'd-none': hide_evaluation_criteria == true && evaluator_view,
              }"
            >
              {{
                $getVisibleNames(
                  "teaching.evaluationcriteriamicro",
                  false,
                  "Criterio de Evaluación Micro"
                ).toUpperCase()
              }}
            </th>
            <!-- Niveles de Logro Insertados -->
            <th
              v-for="rubric_achievement in rubricAchievementList"
              :key="rubric_achievement.id"
              style="width: auto"
            >
              {{ rubric_achievement.title.toUpperCase() }}
              <br />
              {{ rubric_achievement.score }}
              <template v-if="rubric.show_percentage_sign">%</template>
              <template v-else>
                {{
                  $t("evaluations.newEvaluations.points").toUpperCase()
                }}</template
              >
              <ButtonSmall
                v-if="allows_crud && !rubric.is_locked"
                :tooltip_text="
                  $t('reusable.common.editTooltip', {
                    entity: $getVisibleNames(
                      'evaluations2.rubricperformancelevel',
                      false,
                      'Niveles de Logro'
                    ),
                  })
                "
                :click_button="
                  () =>
                    $bvModal.show(
                      `modal-update-rubric-achievement-${instrument_id}-${rubric_achievement.id}-${container_instrument_id}`
                    )
                "
                :custom_class="`add-button mx-1`"
                :icon="'square'"
              ></ButtonSmall>
              <ButtonSmall
                v-if="allows_crud && !rubric.is_locked"
                :tooltip_text="
                  $t('reusable.common.deleteTooltip', {
                    entity: $getVisibleNames(
                      'evaluations2.rubricperformancelevel',
                      false,
                      'Niveles de Logro'
                    ),
                  })
                "
                :click_button="
                  () => deleteRubricAchievement(rubric_achievement.id)
                "
                :custom_class="`add-button`"
                :icon="'trash'"
                :variant="'danger'"
                :variant_icon="'light'"
              ></ButtonSmall>
              <div v-if="user_id && evaluator_view">
                <ButtonSmall
                  :variant="'secondary'"
                  :tooltip_text="
                    $t('evaluations.newEvaluations.assignEntityToEntity', {
                      entity1: $getVisibleNames(
                        'evaluations2.rubricperformancelevel',
                        false,
                        'Niveles de Logro'
                      ),
                      entity2: $getVisibleNames(
                        'evaluations2.rubric',
                        false,
                        'Pauta'
                      ),
                    })
                  "
                  :custom_class="`p-1`"
                  :disabled_button="!closedEvaluationScore"
                  @click="setRubricPerformanceLevel(rubric_achievement.id)"
                >
                  <template #icon>
                    <b-icon-check-square></b-icon-check-square>
                  </template>
                </ButtonSmall>
              </div>
              <!-- <b-button
                v-if="allows_crud && !rubric.is_locked"
                v-b-tooltip.top.noninteractive.v-secondary="
                  `Eliminar ${$getVisibleNames(
                    'evaluations2.rubricperformancelevel',
                    false,
                    'Niveles de Logro'
                  )}`
                "
                class="action-button-delete delete-btn"
                variant="none"
                @click="deleteRubricAchievement(rubric_achievement.id)"
              >
                <b-icon-trash font-scale="1"></b-icon-trash>
              </b-button> -->
              <!-- v-can="'evaluations2.delete_evaluation'" -->

              <b-modal
                :id="`modal-update-rubric-achievement-${instrument_id}-${rubric_achievement.id}-${container_instrument_id}`"
                :title="
                  $t('reusable.common.deleteTooltip', {
                    entity: $getVisibleNames(
                      'evaluations2.rubricperformancelevel',
                      false,
                      'Niveles de Logro'
                    ),
                  })
                "
                size="lg"
                hide-footer
                ignore-enforce-focus-selector="#sidebar-right"
              >
                <RubricAchievementForm
                  :rubric_id="rubric.id"
                  :RubricAchievement="rubric_achievement"
                  :order="rubric_achievement.order"
                  :show_delete_button="true"
                  @updated="
                    $bvModal.hide(
                      `modal-update-rubric-achievement-${instrument_id}-${rubric_achievement.id}-${container_instrument_id}`
                    )
                  "
                  @deleted="
                    $bvModal.hide(
                      `modal-update-rubric-achievement-${instrument_id}-${rubric_achievement.id}-${container_instrument_id}`
                    )
                  "
                ></RubricAchievementForm>
              </b-modal>
            </th>
            <th v-if="rubricAchievementList.length == 0">
              {{ $t("evaluations.newEvaluations.doesNotHave") }}
              {{
                $getVisibleNames(
                  "evaluations2.rubricperformancelevel",
                  true,
                  "Niveles de Logro"
                )
              }}
            </th>
            <!-- Ponderación -->
            <th
              style="width: 1%"
              :class="{ 'd-none': hide_weighing == true && evaluator_view }"
              v-b-tooltip.top.noninteractive.v-secondary="
                institution && institution.internal_use_id != 'duoc.cl'
                  ? $t(
                      'evaluations.newEvaluations.correspondsToPonderationOf',
                      {
                        entity: $getVisibleNames(
                          'manual.dimension',
                          false,
                          'Dimensión'
                        ),
                      }
                    )
                  : ''
              "
            >
              %
            </th>
            <!-- Columna Editar -->
            <th style="width: 1%" v-if="allows_crud && !rubric.is_locked"></th>
            <!-- Nueva columna header -->
            <th
              style="width: 100px"
              v-if="
                (evaluator_view ||
                  (evaluatee_view && finished_test && is_published)) &&
                user_id
              "
            >
              {{ $t("evaluations.newEvaluations.manualScoreFeedback") }}
            </th>
          </tr>
        </thead>
        <draggable
          v-model="rubricInstanceList"
          :disabled="!allows_crud || rubric.is_locked"
          tag="tbody"
          handle=".handle"
        >
          <template v-for="rubric_criteria in rubricInstanceList">
            <tr :key="`${rubric_criteria.id}`">
              <td
                class="handle"
                :class="{ 'd-none': hide_number == true && evaluator_view }"
              >
                <b-icon
                  v-if="allows_crud && !rubric.is_locked"
                  class="handle-icon"
                  icon="arrows-expand"
                  scale="1.2"
                ></b-icon>
                <template v-else>
                  {{ rubric_criteria.order }}
                </template>
              </td>
              <td
                class="td-rubric-descriptor-cell"
                :class="{ 'd-none': hide_dimension == true && evaluator_view }"
              >
                <div class="container-dimension">
                  <div class="pt-1 sentence-cell">
                    <SentenceContainer
                      class="ml-1"
                      :class="{
                        'unselectable-text':
                          (user && user.group_names.includes('ESTUDIANTES')) ||
                          preview_evaluation,
                      }"
                      :unique_id_sentence="
                        rubric_criteria.id +
                        '-' +
                        rubric_criteria.order +
                        rubric_criteria.full_sentence
                      "
                      :Sentence="rubric_criteria"
                      :showColorCognitiveLevel="allows_crud"
                      :showCognitiveLevel="!preview_evaluation"
                      :boundedTextContainer="
                        (evaluator_view ||
                          evaluatee_view ||
                          preview_evaluation) &&
                        rubric &&
                        !rubric.allow_criteria_performance_level_input
                          ? true
                          : false
                      "
                      :single_line="
                        (evaluator_view ||
                          evaluatee_view ||
                          preview_evaluation) &&
                        rubric &&
                        !rubric.allow_criteria_performance_level_input
                          ? true
                          : false
                      "
                    ></SentenceContainer>
                  </div>
                </div>
              </td>
              <td
                v-if="
                  evaluation &&
                  (evaluation.matter_evaluation != null ||
                    evaluation.egress_profile_matter_evaluation != null ||
                    (evaluation.parent_evaluation != null &&
                      evaluation_criteria_micro_ids.length >= 0) ||
                    evaluation_criteria_micro_ids.length > 0) &&
                  institution &&
                  institution.internal_use_id != 'duoc.cl'
                "
                class="td-rubric-descriptor-cell"
                :class="{
                  'd-none': hide_evaluation_criteria == true && evaluator_view,
                }"
              >
                <div class="contailer-il-rubric">
                  <div
                    v-for="ec_micros in rubric_criteria.evaluation_criterias_micro"
                    :key="
                      ec_micros +
                      'evaluation_criterias_micro' +
                      rubric_criteria.id
                    "
                  >
                    <div class="pt-1 sentence-cell container-sentence">
                      <SentenceContainer
                        v-if="
                          evaluation_criteria_micros.find(
                            (x) => x.id == ec_micros
                          )
                        "
                        class="ml-1 text-cell-sencente"
                        :class="{
                          'unselectable-text':
                            (user &&
                              user.group_names.includes('ESTUDIANTES')) ||
                            preview_evaluation,
                        }"
                        :unique_id_sentence="
                          rubric_criteria.id +
                          '-' +
                          rubric_criteria.order +
                          ec_micros
                        "
                        :Sentence="
                          evaluation_criteria_micros.find(
                            (x) => x.id == ec_micros
                          )
                        "
                        :showColorCognitiveLevel="allows_crud"
                        :showCognitiveLevel="!preview_evaluation"
                        :boundedTextContainer="false"
                      >
                        <template v-slot:order>
                          <span>
                            {{ orderEvaluationCriteriaMicro(ec_micros) }}
                          </span>
                        </template>
                      </SentenceContainer>
                    </div>
                  </div>
                </div>
                <div
                  v-if="rubric_criteria.evaluation_criterias_micro.length == 0"
                  class="d-flex ml-1 mr-auto mt-1"
                >
                  {{ $t("reusable.common.notApplicable") }}
                </div>
              </td>
              <td
                v-for="rubric_achievement in rubricAchievementList"
                :key="rubric_achievement.id"
                class="td-rubric-descriptor-cell"
                :class="{
                  'vertical-align-cell':
                    rubric && !rubric.allow_criteria_performance_level_input,
                }"
              >
                <RubricDescriptorCell
                  :class="{
                    'unselectable-text':
                      (user && user.group_names.includes('ESTUDIANTES')) ||
                      preview_evaluation,
                  }"
                  :key="
                    rubric_criteria.id +
                    '-' +
                    rubric_achievement.id +
                    '-' +
                    key_rubric_descriptor_cell
                  "
                  :container_instrument_id="container_instrument_id"
                  :rubric="rubric"
                  :rubric_criteria_id="rubric_criteria.id"
                  :rubric_achievement_id="rubric_achievement.id"
                  :allows_crud="allows_crud && !rubric.is_locked"
                  :evaluator_view="evaluator_view"
                  :evaluatee_view="evaluatee_view"
                  :is_running_test="is_running_test"
                  :finished_test="finished_test"
                  :is_published="is_published"
                  :preview_evaluation="preview_evaluation"
                  :user_id="currentUserId"
                  :coevaluator_id="currentCoevaluatorId"
                  :closedEvaluationScore="closedEvaluationScore"
                  @created_score="changeEvaluateeTest"
                  @updated_score="changeEvaluateeTest"
                  @resetRubricDescriptorCell="
                    () => key_rubric_descriptor_cell++
                  "
                >
                  <template #calculated_score>
                    <div v-if="!evaluatee_view">
                      <b-badge
                        v-if="test && rubric_criteria && rubric_achievement"
                        v-b-tooltip.top.noninteractive.v-secondary="
                          $t('evaluations.newEvaluations.scoreOf', {
                            entity: $getVisibleNames(
                              'evaluations2.rubricperformancelevel',
                              false,
                              'Niveles de Logro'
                            ),
                          })
                        "
                        class="mr-1 text-center"
                        >{{
                          calculateRubricScore(
                            rubric_achievement,
                            rubric_criteria
                          ) | Round
                        }}</b-badge
                      >
                    </div>
                  </template>
                </RubricDescriptorCell>
              </td>
              <td
                :class="{ 'd-none': hide_weighing == true && evaluator_view }"
              >
                <div
                  :class="{ 'weighing-red': rubric_criteria.weighing == 0 }"
                  v-b-tooltip.top.danger.v-danger="
                    rubric_criteria.weighing == 0
                      ? $t('evaluations.newEvaluations.entityDoesNotWeigh', {
                          entity: $getVisibleNames(
                            'manual.dimension',
                            false,
                            'Dimensión'
                          ),
                        })
                      : ''
                  "
                >
                  {{ $truncateToDecimals(rubric_criteria.weighing) }}%
                </div>
              </td>
              <td v-if="rubricAchievementList.length == 0"></td>
              <!-- Nueva celda vacía cuando no hay niveles de logro -->
              <td
                v-if="
                  rubricAchievementList.length == 0 &&
                  (evaluator_view ||
                    (evaluatee_view && finished_test && is_published)) &&
                  user_id
                "
              ></td>
              <td v-if="allows_crud && !rubric.is_locked">
                <div class="container-buttons-dimension">
                  <ButtonSmall
                    v-if="allows_crud"
                    :tooltip_text="
                      $t('reusable.common.editTooltip', {
                        entity: $getVisibleNames(
                          'manual.dimension',
                          false,
                          'Dimensión'
                        ),
                      })
                    "
                    :click_button="
                      () => openModalDimensionEdit(rubric_criteria.id)
                    "
                    :custom_class="``"
                    :icon="'square'"
                  ></ButtonSmall>

                  <ButtonSmall
                    v-if="allows_crud"
                    :tooltip_text="
                      $t('reusable.common.deleteTooltip', {
                        entity: $getVisibleNames(
                          'manual.dimension',
                          false,
                          'Dimensión'
                        ),
                      })
                    "
                    :click_button="
                      () => deleteRubricCriteria(rubric_criteria.id)
                    "
                    :custom_class="``"
                    :icon="'trash'"
                  ></ButtonSmall>

                  <!-- <b-button
                    v-if="allows_crud"
                    v-b-tooltip.top.noninteractive.v-secondary="
                      `Eliminar la ${$getVisibleNames(
                        'manual.dimension',
                        false,
                        'Dimensión'
                      )}`
                    "
                    class="action-button-delete-dimension delete-btn"
                    variant="none"
                    @click="deleteRubricCriteria(rubric_criteria.id)"
                  >
                    <b-icon-trash
                      class="icon-trash"
                      font-scale="1"
                    ></b-icon-trash>
                  </b-button> -->
                  <!-- v-can="'evaluations2.delete_evaluation'" -->
                </div>
                <b-modal
                  :id="`modal-update-rubric-instance-${instrument_id}-${rubric_criteria.id}-${container_instrument_id}`"
                  :title="
                    $t('reusable.common.modifyTooltip', {
                      entity: $getVisibleNames(
                        'manual.dimension',
                        false,
                        'Dimensión'
                      ),
                    })
                  "
                  hide-footer
                  size="xl"
                  ignore-enforce-focus-selector="#sidebar-right"
                  @hide="hideModalDimension"
                >
                  <RubricCriteriaForm
                    v-if="rubric"
                    :rubric_id="rubric.id"
                    :RubricCriteria="rubric_criteria"
                    :order="rubric_criteria.order"
                    :evaluation_criteria_micro_ids="
                      evaluation_criteria_micro_ids
                    "
                    :show_delete_button="true"
                    @updated="
                      $bvModal.hide(
                        `modal-update-rubric-instance-${instrument_id}-${rubric_criteria.id}-${container_instrument_id}`
                      )
                    "
                    @deleted="
                      $bvModal.hide(
                        `modal-update-rubric-instance-${instrument_id}-${rubric_criteria.id}-${container_instrument_id}`
                      )
                    "
                  ></RubricCriteriaForm>
                </b-modal>
              </td>
              <!-- Nueva celda de acción -->
              <td
                v-if="
                  (evaluator_view ||
                    (evaluatee_view && finished_test && is_published)) &&
                  user_id
                "
              >
                <div class="d-flex flex-column align-items-center">
                  <!-- Input para puntaje manual con validaciones -->
                  <div class="w-100 px-1 mb-1">
                    <b-form-input
                      v-if="evaluator_view"
                      class="w-100"
                      type="number"
                      :min="
                        getMinRubricAchievementValueForDimension(
                          rubric_criteria.id
                        )
                      "
                      :max="
                        getMaxRubricAchievementValueForDimension(
                          rubric_criteria.id
                        )
                      "
                      size="sm"
                      :placeholder="'0'"
                      :value="getManualScore(rubric_criteria.id)"
                      @input="setTempManualScore(rubric_criteria.id, $event)"
                      @keyup.enter="saveManualScore(rubric_criteria.id)"
                      :disabled="!closedEvaluationScore"
                      :class="{
                        'is-invalid': !isValidScore(rubric_criteria.id),
                      }"
                    ></b-form-input>
                    <template
                      v-else-if="getManualScore(rubric_criteria.id) > 0"
                    >
                      {{ getManualScore(rubric_criteria.id) }}
                    </template>
                  </div>
                  <!-- Mensaje de error de validación -->
                  <small
                    v-if="
                      evaluator_view &&
                      !isValidScore(rubric_criteria.id) &&
                      getTempManualScore(rubric_criteria.id)
                    "
                    class="text-danger mb-1"
                  >
                    {{
                      $t("evaluations.newEvaluations.mustBeBetween", {
                        entity1: getMinRubricAchievementValueForDimension(
                          rubric_criteria.id
                        ),
                        entity2: getMaxRubricAchievementValueForDimension(
                          rubric_criteria.id
                        ),
                      })
                    }}
                  </small>

                  <div
                    class="d-flex w-100 justify-content-end align-items-center"
                    v-if="evaluator_view"
                  >
                    <strong class="me-2"
                      >{{ $t("reusable.common.save") }}:</strong
                    >
                    <ButtonSmall
                      v-if="evaluator_view"
                      :tooltip_text="`${$t(
                        'evaluations.newEvaluations.saveScore'
                      )} (${getMinRubricAchievementValueForDimension(
                        rubric_criteria.id
                      )}-${getMaxRubricAchievementValueForDimension(
                        rubric_criteria.id
                      )})`"
                      :click_button="() => saveManualScore(rubric_criteria.id)"
                      class="mb-1 mr-1"
                      :custom_class="`p-1`"
                      :icon="'save'"
                      :variant="'primary'"
                      :disabled_button="
                        !closedEvaluationScore ||
                        !isValidScore(rubric_criteria.id)
                      "
                    ></ButtonSmall>
                  </div>
                  <!-- Botón para abrir modal de Retroalimentación -->
                  <div
                    class="d-flex w-100 justify-content-end align-items-center"
                  >
                    <strong class="me-2"
                      >{{
                        $t(
                          "evaluations.newEvaluations.feedbackLabel"
                        ).toLowerCase()
                      }}:</strong
                    >
                    <ButtonSmall
                      :tooltip_text="`${
                        evaluator_view
                          ? getFeedback(rubric_criteria.id)
                            ? $t('evaluations.newEvaluations.viewEditFeedback')
                            : $t('evaluations.newEvaluations.addFeedback')
                          : getFeedback(rubric_criteria.id)
                          ? $t('evaluations.newEvaluations.viewFeedback')
                          : $t('evaluations.newEvaluations.withoutFeedback')
                      }`"
                      :click_button="
                        () =>
                          $bvModal.show(
                            `modal-feedback-${instrument_id}-${rubric_criteria.id}`
                          )
                      "
                      :icon="'card-heading'"
                      class="mr-1"
                      :custom_class="`p-1`"
                      :variant="
                        getFeedback(rubric_criteria.id)
                          ? 'success'
                          : 'secondary'
                      "
                    ></ButtonSmall>
                  </div>

                  <!-- Modal de feedback específico para cada dimensión -->
                  <b-modal
                    :id="`modal-feedback-${instrument_id}-${rubric_criteria.id}`"
                    :title="`${$getVisibleNames(
                      'manual.dimension',
                      false,
                      'Dimensión'
                    )} - ${$t('evaluations.newEvaluations.feedbackLabel')}`"
                    size="lg"
                    hide-footer
                  >
                    <div class="mb-3">
                      <label
                        ><strong>
                          {{
                            $t(
                              "evaluations.newEvaluations.evaluatedDimension",
                              {
                                entity: $getVisibleNames(
                                  "manual.dimension",
                                  false,
                                  "Dimensión"
                                ),
                              }
                            )
                          }}
                          :</strong
                        ></label
                      >
                      <p class="mb-2">{{ rubric_criteria.full_sentence }}</p>
                    </div>
                    <div class="mb-3">
                      <label for="feedback-textarea"
                        ><strong
                          >{{
                            $t("evaluations.newEvaluations.feedbackLabel")
                          }}:</strong
                        ></label
                      >
                      <template v-if="evaluator_view">
                        <div
                          class="feedback-description mr-0 mt-1"
                          @click="
                            $bvModal.show(
                              `edit-feedback-description-modal-${rubric_criteria.id}`
                            )
                          "
                        >
                          <RenderVHtml
                            v-b-tooltip.v-secondary.noninteractive.hover="{
                              title: $t(
                                'evaluations.newEvaluations.editFeedback'
                              ),
                              boundary: 'viewport',
                            }"
                            :content="getFeedback(rubric_criteria.id)"
                          ></RenderVHtml>
                        </div>
                        <ContainerRichTextKlv3
                          :id_modal="`edit-feedback-description-modal-${rubric_criteria.id}`"
                          :title_modal="
                            $t('evaluations.newEvaluations.editFeedback')
                          "
                          :size_modal="`lg`"
                          :content_rich_text="getFeedback(rubric_criteria.id)"
                          :permit_blank="true"
                          @save="
                            (content) =>
                              updateFeedback(rubric_criteria.id, content)
                          "
                          @close="
                            $bvModal.hide(
                              `edit-feedback-description-modal-${rubric_criteria.id}`
                            )
                          "
                        >
                        </ContainerRichTextKlv3>
                      </template>
                      <template v-else>
                        <RenderVHtml
                          :content="getFeedback(rubric_criteria.id)"
                        ></RenderVHtml>
                        <template v-if="!getFeedback(rubric_criteria.id)">
                          -
                          {{
                            $t("evaluations.newEvaluations.withoutFeedback")
                          }}</template
                        >
                      </template>
                    </div>
                  </b-modal>
                </div>
              </td>
            </tr>
          </template>
        </draggable>
        <template v-if="rubricInstanceList.length == 0">
          <tbody>
            <b-tr>
              <b-td
                :colspan="
                  (allows_crud
                    ? 5 + rubricAchievementList.length
                    : 4 + rubricAchievementList.length) +
                  ((evaluator_view ||
                    (evaluatee_view && finished_test && is_published)) &&
                  user_id
                    ? 1
                    : 0)
                "
              >
                <strong>
                  {{
                    $t("evaluations.newEvaluations.thisNoCreated", {
                      entity: $getVisibleNames(
                        "manual.dimension",
                        true,
                        "Dimensiones"
                      ),
                    })
                  }}
                </strong>
              </b-td>
            </b-tr>
          </tbody>
        </template>
        <tfoot
          v-if="filter_rubric_instance == null"
          :class="{ 'd-none': hide_weighing == true && evaluator_view }"
        >
          <tr>
            <td
              :class="{
                'd-none':
                  (institution &&
                    institution.internal_use_id == 'duoc.cl' &&
                    hide_dimension == true &&
                    hide_number == true &&
                    evaluator_view) ||
                  (institution &&
                    institution.internal_use_id != 'duoc.cl' &&
                    hide_dimension == true &&
                    hide_number == true &&
                    hide_evaluation_criteria == true &&
                    evaluator_view),
              }"
              :colspan="colspanRubric"
            ></td>
            <td
              v-for="(rubric_achievement, index) in rubricAchievementList"
              :key="rubric_achievement.id"
            >
              <template v-if="rubricAchievementList.length == index + 1">
                <strong>{{ $t("evaluations.newEvaluations.total") }}</strong>
              </template>
            </td>
            <td v-if="rubricAchievementList.length == 0">
              <strong>{{ $t("evaluations.newEvaluations.total") }}</strong>
            </td>
            <td
              :title="
                totalWeighing != 100
                  ? $t('evaluations.newEvaluations.totalWeightingMustEqual100')
                  : ''
              "
              v-b-tooltip.v-secondary.noninteractive
              v-bind:style="{ color: totalWeighing != 100 ? 'red' : '' }"
            >
              <strong>{{ $truncateToDecimals(totalWeighing) }}%</strong>
            </td>
            <td v-if="allows_crud && !rubric.is_locked"></td>
            <!-- Nueva celda en footer -->
            <td
              v-if="
                (evaluator_view ||
                  (evaluatee_view && finished_test && is_published)) &&
                user_id
              "
            ></td>
          </tr>
        </tfoot>
      </table>
    </div>
    <b-modal
      :id="`modal-created-rubric-criteria-${instrument_id}-${container_instrument_id}`"
      :title="
        $t('reusable.common.createTooltip', {
          entity: $getVisibleNames('manual.dimension', false, 'Dimensión'),
        })
      "
      size="xl"
      hide-footer
      ignore-enforce-focus-selector="#sidebar-right"
      @hide="hideModalDimension"
    >
      <RubricCriteriaForm
        v-if="rubric"
        :rubric_id="rubric.id"
        :evaluation_criteria_micro_ids="evaluation_criteria_micro_ids"
        :order="
          rubricInstanceList.length > 0
            ? rubricInstanceList[rubricInstanceList.length - 1].order + 1
            : 1
        "
        @created="
          $bvModal.hide(
            `modal-created-rubric-criteria-${instrument_id}-${container_instrument_id}`
          )
        "
      ></RubricCriteriaForm>
    </b-modal>
    <b-modal
      :id="`modal-create-rubric-achievement-${instrument_id}-${container_instrument_id}`"
      :title="
        $t('reusable.common.createTooltip', {
          entity: $getVisibleNames(
            'evaluations2.rubricperformancelevel',
            false,
            'Niveles de Logro'
          ),
        })
      "
      size="lg"
      hide-footer
      ignore-enforce-focus-selector="#sidebar-right"
    >
      <RubricAchievementForm
        v-if="rubric"
        :rubric_id="rubric.id"
        :order="
          rubricAchievementList.length > 0
            ? rubricAchievementList[rubricAchievementList.length - 1].order + 1
            : 1
        "
        @created="
          $bvModal.hide(
            `modal-create-rubric-achievement-${instrument_id}-${container_instrument_id}`
          )
        "
      ></RubricAchievementForm>
    </b-modal>
    <b-modal
      :id="`modal-create-rubric-${instrument_id}-${container_instrument_id}`"
      :title="
        $t('reusable.common.createTooltip', {
          entity: $getVisibleNames('evaluations2.rubric', false, 'Pauta'),
        })
      "
      size="lg"
      hide-footer
      ignore-enforce-focus-selector="#sidebar-right"
    >
      <NewRubricForm
        :test_id="instrument_id"
        @closeModal="
          $bvModal.hide(
            `modal-create-rubric-${instrument_id}-${container_instrument_id}`
          )
        "
      ></NewRubricForm>
    </b-modal>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
import { toast, showLoadingAlert } from "@/utils/utils";

export default {
  name: "RubricsContainer",
  components: {
    draggable,
    NewSpecificationTable: () =>
      import(
        "@/components/new-evaluations/Evaluation/SpecificationTable/NewSpecificationTable"
      ),
    RubricCriteriaForm: () =>
      import("@/components/new-evaluations/Rubrics/RubricCriteriaForm"),
    NewRubricForm: () =>
      import("@/components/new-evaluations/Rubrics/NewRubricForm"),
    CoEvaluatorRubric: () =>
      import("@/components/new-evaluations/Rubrics/CoEvaluatorRubric"),
    SentenceContainer: () => import("@/components/reusable/SentenceContainer"),
    RubricAchievementForm: () =>
      import("@/components/new-evaluations/Rubrics/RubricAchievementForm"),
    RubricDescriptorCell: () =>
      import("@/components/new-evaluations/Rubrics/RubricDescriptorCell"),
    HeaderRubric: () =>
      import("@/components/new-evaluations/Rubrics/HeaderRubric"),
    SelectedCoevaluatorRubric: () =>
      import("@/components/new-evaluations/Rubrics/SelectedCoevaluatorRubric"),
    ButtonMedium: () =>
      import("@/components/reusable/Buttons/Medium/ButtonMedium"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    instrument_id: {
      required: true,
      type: Number,
    },
    evaluation_criteria_micro_ids: {
      type: Array,
      required: true,
    },
    container_instrument_id: {
      type: String,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    preview_evaluation: {
      type: Boolean,
      required: true,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
    evaluatee_view: {
      type: Boolean,
      default: false,
    },
    is_running_test: {
      type: Boolean,
      default: false,
    },
    finished_test: {
      type: Boolean,
      default: false,
    },
    is_published: {
      type: Boolean,
      default: false,
    },
    user_id: {
      type: Number,
      required: false,
    },
    // para restringir que el evaluador pueda colocar notas fuera del periodo actual con respecto al de la sección.
    closedEvaluationScore: {
      type: Boolean,
      default: false,
    },
    // Para que solo uno de los componentes pida las peticiones y el otro solo sirva para el imprimir todos los test en la misma línea.
    // y eso se ejecutaria solo si es !evaluatee_view && !evaluator_view
    requests_within_the_component: {
      type: Boolean,
      default: true,
    },
    // para que cuando se llame el componente no haga las peticiones nuevamente.
    no_requests_in_view: {
      type: Boolean,
      default: false,
    },
    // Filtro para mostrar las preguntas en "NewQuestionCard"
    filter_rubric_instance: {
      type: Number,
    },
  },
  data() {
    return {
      key_rubric_descriptor_cell: 0,
      key_coevaluator_rubric: 0,
      coevaluator_id: null,
      hide_number: false,
      hide_dimension: false,
      hide_weighing: false,
      hide_evaluation_criteria: false,
      tempManualScores: {}, // Valores temporales antes de guardar
      feedbackTimeouts: {}, // Para debounce de feedback
      creatingPerformanceLevels: {}, // Guard anti-duplicado por rubric_criteria_id mientras el POST está en vuelo
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      evaluations: names.NEW_EVALUATIONS,
      tests: names.NEW_TESTS,
      evaluative_agents: names.NEW_TEST_TYPES,
      competence_units: names.COMPETENCE_UNITS,
      study_units: names.STUDY_UNITS,
      evaluation_criteria_micros: names.EVALUATION_CRITERIAS,
      rubrics: names.NEW_RUBRIC_INSTRUMENTS,
      rubricAchievements: names.NEW_RUBRIC_ACHIEVEMENTS,
      rubricInstances: names.NEW_RUBRIC_CRITERIAS,
      rubricDescriptors: names.NEW_RUBRIC_DESCRIPTORS,
      evaluatee_rubrics: names.EVALUATEE_RUBRICS,
      egress_profile_matters: names.EGRESS_PROFILES_MATTERS,
      sections: names.SECTIONS,
      evaluateeRubricCriteriaPerformanceLevels:
        names.EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVELS,
    }),
    test() {
      return this.tests.find((x) => x.id == this.instrument_id);
    },
    evaluation() {
      if (!this.test) return null;
      return this.evaluations.find((x) => x.id == this.test.evaluation);
    },
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections.find((x) => x.id == this.evaluation.scope_id);
      else return null;
    },
    egressProfileMatter() {
      if (
        this.evaluation &&
        this.evaluation.scope == 2 &&
        this.evaluation.scope_id != null
      ) {
        return this.egress_profile_matters.find(
          (x) => x.id == this.evaluation.scope_id
        );
      }
      if (
        this.evaluation &&
        this.evaluation.scope == 1 &&
        this.section &&
        this.section.egress_profile_matter != null
      ) {
        return this.egress_profile_matters.find(
          (x) => x.id == this.section.egress_profile_matter
        );
      }
      return null;
    },
    evaluative_agent() {
      if (!this.test) return null;
      return this.evaluative_agents.find(
        (x) => this.test.evaluative_agent == x.id
      );
    },
    rubric() {
      return this.rubrics.find((x) => x.test == this.instrument_id);
    },
    evaluateeRubric() {
      if (
        this.user_id &&
        this.rubric &&
        (this.evaluatee_view || this.evaluator_view)
      )
        return this.evaluatee_rubrics.find(
          (x) => x.evaluatee == this.user_id && x.rubric == this.rubric.id
        );
      return null;
    },
    selectedUsers() {
      if (!this.evaluateeRubric) return [];
      if (this.evaluatee_view && this.is_running_test && !this.finished_test) {
        return this.evaluateeRubric.coevaluators;
      } else if (this.evaluator_view) {
        return this.evaluateeRubric.coevaluating;
      } else if (this.evaluatee_view && this.finished_test) {
        // El evaluado solo ve quiénes lo coevaluaron si la rúbrica lo permite
        if (!this.rubric.evaluatee_can_see_coevaluator) return [];
        return this.evaluateeRubric.coevaluating;
      }
      return [];
    },
    rubricAchievementFilter() {
      if (!this.rubric) return [];
      return this.rubricAchievements.filter((x) => x.rubric == this.rubric.id);
    },
    maxRubricAchivementValue() {
      const max = this.rubricAchievementFilter.reduce((max, actual) => {
        return actual.score > max.score ? actual : max;
      });
      if (max) return max.score;
      else return 0;
    },
    minRubricAchivementValue() {
      const min = this.rubricAchievementFilter.reduce((min, actual) => {
        return actual.score < min.score ? actual : min;
      });
      if (min) return min.score;
      else return 0;
    },
    rubricAchievementList() {
      let list = this.rubricAchievementFilter.map((x) => {
        return {
          ...x,
          calculated_weighting_of_the_score:
            (x.score - this.minRubricAchivementValue) /
            (this.maxRubricAchivementValue - this.minRubricAchivementValue),
        };
      });
      return list.sort(function (a, b) {
        return a.score > b.score ? -1 : 1;
      });
    },
    colspanRubric() {
      let column = 0;
      if (
        this.evaluation &&
        (this.evaluation.matter_evaluation != null ||
          this.evaluation.egress_profile_matter_evaluation != null ||
          (this.evaluation.parent_evaluation != null &&
            this.evaluation_criteria_micro_ids.length > 0) ||
          this.evaluation_criteria_micro_ids.length > 0) &&
        this.institution &&
        this.institution.internal_use_id == "duoc.cl"
      ) {
        column += 2;
      }
      if (
        this.evaluation &&
        (this.evaluation.matter_evaluation != null ||
          this.evaluation.egress_profile_matter_evaluation != null ||
          (this.evaluation.parent_evaluation != null &&
            this.evaluation_criteria_micro_ids.length >= 0) ||
          this.evaluation_criteria_micro_ids.length > 0) &&
        this.institution &&
        this.institution.internal_use_id != "duoc.cl"
      ) {
        column += 3;
      }
      if (this.hide_number == true && this.evaluator_view) {
        column -= 1;
      }
      if (this.hide_dimension == true && this.evaluator_view) {
        column -= 1;
      }
      if (this.hide_evaluation_criteria == true && this.evaluator_view) {
        column -= 1;
      }
      return column;
    },
    rubricInstanceList: {
      get() {
        if (this.filter_rubric_instance == null) {
          return this.rubricInstances
            .filter((x) => x.rubric == this.rubric.id)
            .sort(function (a, b) {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
              return 0;
            });
        } else {
          return this.rubricInstances
            .filter(
              (x) =>
                x.rubric == this.rubric.id &&
                x.id == this.filter_rubric_instance
            )
            .sort(function (a, b) {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
              return 0;
            });
        }
      },
      set(list) {
        list.forEach((element, index) => {
          if (!isNaN(element.id)) {
            let payload = {
              rubric_instance_id: element.id,
              item: {
                order: index + 1,
              },
            };
            this.$store.dispatch(names.PATCH_NEW_RUBRIC_CRITERIA, payload);
          }
        });
      },
    },
    fields() {
      return [
        {
          key: "title",
          label: this.$t("evaluations.newEvaluations.category").toUpperCase(),
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "white",
          },
          tdClass: "text-left",
        },
        {
          key: "score",
          label:
            this.rubric && this.rubric.show_percentage_sign
              ? this.$t(
                  "evaluations.newEvaluations.percentageAchievement"
                ).toUpperCase()
              : this.$t("evaluations.newEvaluations.score").toUpperCase(),
          tdClass: "text-center",
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "white",
            width: "80px",
          },
          formatter: (value) => {
            if (this.rubric && this.rubric.show_percentage_sign)
              return value + "%";
            else return value;
          },
        },
        {
          key: "description",
          label: this.$t(
            "evaluations.newEvaluations.achievementLevelsDescription"
          ).toUpperCase(),
          thStyle: {
            background: "var(--kl-color-accent-medium) !important",
            color: "white",
          },
          tdClass: "text-left",
        },
      ];
    },
    totalWeighing() {
      let weighing = 0;
      this.rubricInstanceList.forEach((element) => {
        weighing += Number(element.weighing);
      });
      return this.$round(weighing);
    },
    currentUserId() {
      if (
        this.evaluative_agent &&
        (["duoc_coevaluacion_evaluative_agent"].includes(
          this.evaluative_agent.internal_use_id
        ) ||
          this.$equals(this.evaluative_agent.name, "Coevaluación"))
      ) {
        if (this.evaluatee_view && this.is_running_test && !this.finished_test)
          return this.coevaluator_id;
        if (
          (this.evaluatee_view && this.finished_test) ||
          this.evaluator_view
        ) {
          return this.user_id;
        }
      }
      if (
        this.evaluative_agent &&
        (["duoc_autoevaluacion_evaluative_agent"].includes(
          this.evaluative_agent.internal_use_id
        ) ||
          this.$equals(this.evaluative_agent.name, "Autoevaluación"))
      )
        return this.user_id;
      if (
        (this.evaluator_view && this.user_id) ||
        (this.evaluatee_view && this.user_id)
      )
        return this.user_id;
      return null;
    },
    currentCoevaluatorId() {
      if (
        this.evaluative_agent &&
        (["duoc_coevaluacion_evaluative_agent"].includes(
          this.evaluative_agent.internal_use_id
        ) ||
          this.$equals(this.evaluative_agent.name, "Coevaluación"))
      ) {
        if (this.evaluatee_view && this.is_running_test && !this.finished_test)
          return this.user_id;
        if (
          (this.evaluatee_view && this.finished_test) ||
          this.evaluator_view
        ) {
          return this.coevaluator_id;
        }
      }
      if (
        this.evaluative_agent &&
        (["duoc_autoevaluacion_evaluative_agent"].includes(
          this.evaluative_agent.internal_use_id
        ) ||
          this.$equals(this.evaluative_agent.name, "Autoevaluación"))
      )
        return this.user_id;
      return null;
    },
  },
  methods: {
    getMaxRubricAchievementValueForDimension(rubric_criteria_id) {
      const rubricCriteria = this.rubricInstanceList.find(
        (x) => x.id === rubric_criteria_id
      );
      if (!rubricCriteria || this.rubricAchievementList.length === 0)
        return this.maxRubricAchivementValue;

      // Encontrar el achievement con el mayor calculated_weighting_of_the_score
      const maxAchievement = this.rubricAchievementList.reduce(
        (max, current) => {
          return current.calculated_weighting_of_the_score >
            max.calculated_weighting_of_the_score
            ? current
            : max;
        }
      );

      // Usar la misma lógica que calculateRubricScore pero con el achievement máximo
      return (
        (maxAchievement.calculated_weighting_of_the_score *
          rubricCriteria.weighing *
          this.test.max_score) /
        100
      );
    },
    getMinRubricAchievementValueForDimension(rubric_criteria_id) {
      const rubricCriteria = this.rubricInstanceList.find(
        (x) => x.id === rubric_criteria_id
      );
      if (!rubricCriteria || this.rubricAchievementList.length === 0) return 0;

      // Encontrar el achievement con el menor calculated_weighting_of_the_score
      const minAchievement = this.rubricAchievementList.reduce(
        (min, current) => {
          return current.calculated_weighting_of_the_score <
            min.calculated_weighting_of_the_score
            ? current
            : min;
        }
      );

      // Usar la misma lógica que calculateRubricScore pero con el achievement mínimo
      return (
        (minAchievement.calculated_weighting_of_the_score *
          rubricCriteria.weighing *
          this.test.max_score) /
        100
      );
    },
    calculateRubricScore(rubric_achievement, rubric_criteria) {
      if (!rubric_achievement || !rubric_criteria || !this.test) {
        return 0;
      }
      if (
        rubric_achievement.calculated_weighting_of_the_score === undefined ||
        rubric_criteria.weighing === undefined ||
        this.test.max_score === undefined
      ) {
        return 0;
      }
      return (
        (rubric_achievement.calculated_weighting_of_the_score *
          rubric_criteria.weighing *
          this.test.max_score) /
        100
      );
    },
    getPerformanceLevelByScore(score, rubric_criteria_id) {
      const rubricCriteria = this.rubricInstanceList.find(
        (x) => x.id === rubric_criteria_id
      );
      if (!rubricCriteria || this.rubricAchievementList.length === 0)
        return null;

      // Validar que score sea un número válido
      const parsedScore = parseFloat(score);
      if (isNaN(parsedScore)) {
        return null;
      }
      // Calcular el score equivalente para cada level de performance
      const levelsWithCalculatedScore = this.rubricAchievementList
        .filter(
          (achievement) =>
            achievement &&
            achievement.calculated_weighting_of_the_score !== undefined
        )
        .map((achievement) => {
          const calculatedScore = this.calculateRubricScore(
            achievement,
            rubricCriteria
          );
          return {
            id: achievement.id,
            calculatedScore,
            distance: Math.abs(calculatedScore - parsedScore),
          };
        });
      // Si el score coincide exactamente, devolver ese level
      const exactMatch = levelsWithCalculatedScore.find(
        (level) => level.calculatedScore === parsedScore
      );
      if (exactMatch) return exactMatch.id;
      // Encontrar el nivel más próximo (menor distancia)
      const minDistance = Math.min(
        ...levelsWithCalculatedScore.map((level) => level.distance)
      );
      const closestLevels = levelsWithCalculatedScore.filter(
        (level) => level.distance === minDistance
      );
      // Si hay empate en distancias, tomar el de mayor score
      if (closestLevels.length > 1) {
        const maxScore = Math.max(
          ...closestLevels.map((level) => level.calculatedScore)
        );
        const bestLevel = closestLevels.find(
          (level) => level.calculatedScore === maxScore
        );
        return bestLevel ? bestLevel.id : null;
      }
      // Si solo hay uno más próximo, verificar si es el menor score
      const closestLevel = closestLevels[0];
      const minCalculatedScore = Math.min(
        ...levelsWithCalculatedScore.map((level) => level.calculatedScore)
      );
      // Si el más cercano es el menor score, tomar el siguiente superior
      if (closestLevel.calculatedScore === minCalculatedScore) {
        // Ordenar de menor a mayor y tomar el segundo elemento
        const sortedLevels = levelsWithCalculatedScore.sort(
          (a, b) => a.calculatedScore - b.calculatedScore
        );
        return sortedLevels.length > 1
          ? sortedLevels[1].id
          : sortedLevels[0].id;
      }
      // Si no es el menor, devolver el más cercano
      return closestLevel.id;
    },
    fetchEvaluateeRubrics() {
      if (this.user_id && this.test) {
        this.$store.dispatch(names.FETCH_EVALUATEE_EVALUATIONS, {
          evaluatee_id: this.user_id,
          evaluation_id: this.test.evaluation,
        });
        this.$store.dispatch(names.FETCH_EVALUATEE_TESTS, {
          evaluatee_id: this.user_id,
          test_id: this.test.id,
        });
        this.$store.dispatch(names.FETCH_EVALUATEE_RUBRICS, {
          evaluatee_id: this.user_id,
          test_id: this.test.id,
        });
        this.$store
          .dispatch(names.FETCH_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVELS, {
            evaluatee_id: this.user_id,
            test_id: this.test.id,
          })
          .then((response) => {
            const eva_rub_cri_per_lev_ids = response.map((x) => x.id);
            if (eva_rub_cri_per_lev_ids.length > 0) {
              this.$store
                .dispatch(
                  names.FETCH_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVEL_EVALUATORS,
                  {
                    evaluatee_rubric_criteria_performance_levels_ids:
                      eva_rub_cri_per_lev_ids,
                  }
                )
                .then(() => {
                  this.key_rubric_descriptor_cell++;
                });
            } else this.key_rubric_descriptor_cell++;
          });
      }
    },
    setRubricPerformanceLevel(rubric_performance_level_id) {
      showLoadingAlert(
        this.$t("evaluations.newEvaluations.updatingScoresOf", {
          entity: this.$getVisibleNames("evaluations2.rubric", false, "Pauta"),
        }),
        this.$t("evaluations.newEvaluations.pleaseWaitWhileLoading")
      );
      this.$restful
        .Post(
          `/evaluations2/assign_performance_level_to_evaluatee_rubric_criterias/`,
          {
            rubric_performance_level: rubric_performance_level_id,
            evaluatee: this.user_id,
          }
        )
        .then(() => {
          this.fetchEvaluateeRubrics();
          this.$swal.close();
        })
        .catch(() => {
          this.fetchEvaluateeRubrics();
          this.$swal.close();
        });
    },
    insertStoreOpenAiDimension() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);

      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [8],
        disabled_selected_intelligence_option: true,
      });
    },
    openModalDimensionCreate() {
      this.insertStoreOpenAiDimension();
      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          available_evaluation_criteria_micro:
            this.evaluation_criteria_micro_ids,
          extra_label: `${this.$getVisibleNames(
            "manual.dimension",
            false,
            "Dimensión"
          )}`,
          intelligence_option: 8,
          sub_option: 2,
        });
      });
      this.$bvModal.show(
        `modal-created-rubric-criteria-${this.instrument_id}-${this.container_instrument_id}`
      );
    },
    openModalDimensionEdit(rubric_criteria_id) {
      this.insertStoreOpenAiDimension();
      this.$nextTick(() => {
        this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
          available_evaluation_criteria_micro:
            this.evaluation_criteria_micro_ids,
          extra_label: `${this.$getVisibleNames(
            "manual.dimension",
            false,
            "Dimensión"
          )}`,
          intelligence_option: 8,
          sub_option: 2,
        });
      });
      this.$bvModal.show(
        `modal-update-rubric-instance-${this.instrument_id}-${rubric_criteria_id}-${this.container_instrument_id}`
      );
    },
    hideModalDimension() {
      this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
      this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
      this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
        visible_intelligence_options: [7],
      });

      if (
        this.evaluation &&
        this.evaluation.scope == 3 &&
        this.evaluation.scope_id != null
      ) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.evaluation.scope_id,
            extra_context: this.$t(
              "evaluations.newEvaluations.forTheEvaluation"
            ),
            extra_label: "",
            show_message_evaluation_view: true,
            intelligence_option: 7,
          });
        });
      }
      if (
        this.egressProfileMatter &&
        this.evaluation &&
        (this.evaluation.scope == 2 || this.evaluation.scope == 1) &&
        this.evaluation.scope_id != null
      ) {
        this.$nextTick(() => {
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            matter_id: this.egressProfileMatter.matter,
            extra_context: this.$t(
              "evaluations.newEvaluations.forTheEvaluation"
            ),
            show_message_evaluation_view: true,
            intelligence_option: 7,
          });
        });
      }
    },
    updateCheckbox(variable, value) {
      this.$store.commit("setLocalVariable", {
        component: this.$options.name,
        variable,
        value,
      });
    },
    slotStudentSelected(user_id) {
      this.coevaluator_id = user_id;
    },
    changeEvaluateeTest() {
      if (this.user_id && this.test) {
        this.$store.dispatch(names.FETCH_EVALUATEE_TESTS, {
          evaluatee_id: this.user_id,
          test_id: this.instrument_id,
        });
        this.$store.dispatch(names.FETCH_EVALUATEE_EVALUATIONS, {
          evaluatee_id: this.user_id,
          evaluation_id: this.test.evaluation,
        });
      }
    },
    orderEvaluationCriteriaMicro(evaluation_criteria_micro_id) {
      const evaluation_criteria_micro = this.evaluation_criteria_micros.find(
        (x) => x.id == evaluation_criteria_micro_id
      );
      if (evaluation_criteria_micro) {
        const study_unit = this.study_units.find(
          (x) => x.id == evaluation_criteria_micro.study_unit
        );
        if (study_unit) {
          const competence_unit = this.competence_units.find(
            (x) => x.id == study_unit.temp_competence_unit
          );
          if (competence_unit)
            return (
              competence_unit.order +
              "." +
              study_unit.order +
              "." +
              evaluation_criteria_micro.order
            );
          else return study_unit.order + "." + evaluation_criteria_micro.order;
        }
      }
      return null;
    },
    deleteRubricAchievement(rubric_achievement_id) {
      this.$swal({
        title: this.$t(
          "evaluations.newEvaluations.sureDeleteEntityFromRubric",
          {
            entity: this.$getVisibleNames(
              "evaluations2.rubricperformancelevel",
              false,
              "Nivel de Logro"
            ),
          }
        ),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_NEW_RUBRIC_ACHIEVEMENT,
            rubric_achievement_id
          );
        }
      });
    },
    getRubricCriteriaPerformanceLevel(rubric_criteria_id) {
      return this.evaluateeRubricCriteriaPerformanceLevels.find(
        (x) =>
          x.rubric_criteria === rubric_criteria_id &&
          x.evaluatee === this.user_id
      );
    },
    getManualScore(rubric_criteria_id) {
      // Mostrar valor temporal si existe, sino el valor guardado
      if (this.tempManualScores[rubric_criteria_id] !== undefined) {
        return this.tempManualScores[rubric_criteria_id];
      }
      const performanceLevel =
        this.getRubricCriteriaPerformanceLevel(rubric_criteria_id);
      return performanceLevel ? performanceLevel.manual_score || "" : "";
    },
    getTempManualScore(rubric_criteria_id) {
      return this.tempManualScores[rubric_criteria_id];
    },
    setTempManualScore(rubric_criteria_id, value) {
      this.$set(this.tempManualScores, rubric_criteria_id, value);
    },
    isValidScore(rubric_criteria_id) {
      const tempScore = this.tempManualScores[rubric_criteria_id];
      if (!tempScore && tempScore !== 0) return true; // No hay valor temporal

      const score = parseFloat(tempScore);
      if (isNaN(score)) return false;

      return (
        score >=
          this.getMinRubricAchievementValueForDimension(rubric_criteria_id) &&
        score <=
          this.getMaxRubricAchievementValueForDimension(rubric_criteria_id)
      );
    },
    saveManualScore(rubric_criteria_id) {
      if (!this.isValidScore(rubric_criteria_id)) {
        this.$swal({
          title: this.$t("evaluations.newEvaluations.invalidScore"),
          text: this.$t("evaluations.newEvaluations.mustBeBetween", {
            entity1:
              this.getMinRubricAchievementValueForDimension(rubric_criteria_id),
            entity2:
              this.getMaxRubricAchievementValueForDimension(rubric_criteria_id),
          }),

          type: "error",
          confirmButtonText: this.$t("reusable.common.accept"),
        });
        return;
      }

      // Obtener el valor actual (temporal o guardado)
      const currentValue = this.getManualScore(rubric_criteria_id);
      // Validar que existe un valor
      if (
        currentValue === undefined ||
        currentValue === null ||
        currentValue === ""
      ) {
        this.$swal({
          title: this.$t("evaluations.newEvaluations.valueRequired"),
          text: this.$t("evaluations.newEvaluations.scoreValueRequired"),
          type: "error",
          confirmButtonText: this.$t("reusable.common.accept"),
        });
        return;
      }
      const performanceLevel =
        this.getRubricCriteriaPerformanceLevel(rubric_criteria_id);

      // Determinar el performance level automáticamente basado en el score
      const parsedValue = parseFloat(currentValue);
      // Validar que el valor parseado sea válido
      if (isNaN(parsedValue)) {
        this.$swal({
          title: this.$t("evaluations.newEvaluations.invalidScore"),
          text: this.$t("evaluations.newEvaluations.scoreMustBeValidNumber"),
          type: "error",
          confirmButtonText: this.$t("reusable.common.accept"),
        });
        return;
      }
      const autoPerformanceLevelId = this.getPerformanceLevelByScore(
        parsedValue,
        rubric_criteria_id
      );

      if (performanceLevel) {
        // Actualizar puntaje manual existente
        const payload = {
          evaluatee_rubric_criteria_performance_level_id: performanceLevel.id,
          item: {
            manual_score: parsedValue,
            rubric_performance_level: autoPerformanceLevelId,
          },
        };
        this.$store
          .dispatch(
            names.PATCH_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVEL,
            payload
          )
          .then(() => {
            this.changeEvaluateeTest();
          });
      } else {
        // El store recién conoce la fila cuando vuelve el 201, así que un
        // segundo disparo (Enter + botón, doble click) durante ese lapso
        // volvería a entrar aquí y crearía un duplicado. Cortamos con un guard.
        if (this.creatingPerformanceLevels[rubric_criteria_id]) return;
        this.$set(this.creatingPerformanceLevels, rubric_criteria_id, true);
        // Crear nuevo registro de performance level con puntaje manual
        const newPerformanceLevel = {
          rubric_criteria: rubric_criteria_id,
          evaluatee: this.user_id,
          manual_score: parsedValue,
          rubric_performance_level: autoPerformanceLevelId,
        };
        this.$store
          .dispatch(
            names.POST_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVEL,
            newPerformanceLevel
          )
          .then(() => {
            this.changeEvaluateeTest();
          })
          .finally(() => {
            this.$delete(this.creatingPerformanceLevels, rubric_criteria_id);
          });
      }

      // Limpiar valor temporal después de guardar
      this.$delete(this.tempManualScores, rubric_criteria_id);
      toast(
        `${this.$t(
          "evaluations.newEvaluations.manualScoreSaved"
        )}: ${parsedValue}`,
        "success"
      );
    },
    getFeedback(rubric_criteria_id) {
      const performanceLevel =
        this.getRubricCriteriaPerformanceLevel(rubric_criteria_id);
      return performanceLevel ? performanceLevel.feedback || "" : "";
    },
    updateFeedback(rubric_criteria_id, value) {
      const performanceLevel =
        this.getRubricCriteriaPerformanceLevel(rubric_criteria_id);
      if (performanceLevel) {
        // Actualizar feedback existente
        const payload = {
          evaluatee_rubric_criteria_performance_level_id: performanceLevel.id,
          item: {
            feedback: value,
          },
        };
        this.$store.dispatch(
          names.PATCH_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVEL,
          payload
        );
      } else {
        // Mismo guard anti-duplicado: si ya hay un POST en vuelo para este
        // criterio (ej. se guardó puntaje y feedback casi simultáneos), no
        // dispares otro create contra la misma (evaluatee, rubric_criteria).
        if (this.creatingPerformanceLevels[rubric_criteria_id]) return;
        this.$set(this.creatingPerformanceLevels, rubric_criteria_id, true);
        // Crear nuevo registro de performance level con feedback
        const newPerformanceLevel = {
          rubric_criteria: rubric_criteria_id,
          evaluatee: this.user_id,
          feedback: value,
        };
        this.$store
          .dispatch(
            names.POST_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVEL,
            newPerformanceLevel
          )
          .finally(() => {
            this.$delete(this.creatingPerformanceLevels, rubric_criteria_id);
          });
      }
      // Mostrar toast solo si hay contenido
      if (value && value.trim()) {
        toast(this.$t("evaluations.newEvaluations.feedbackSaved"), "success");
      }
      this.$bvModal.hide(
        `modal-feedback-${this.instrument_id}-${rubric_criteria_id}`
      );
    },
    deleteRubricCriteria(rubric_criteria_id) {
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames("manual.dimension", false, "Dimensión"),
        }),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch(
            names.DELETE_NEW_RUBRIC_CRITERIA,
            rubric_criteria_id
          );
        }
        this.$store.dispatch(names.FETCH_NEW_TEST, {
          test_id: this.instrument_id,
          forceFetch: true,
        });
      });
    },
    createdRubric() {
      this.$store.dispatch(names.POST_NEW_RUBRIC_INSTRUMENT, {
        title: "",
        test: this.instrument_id,
        files: [],
      });
    },
    askForDeteleRubric() {
      this.$swal({
        title: this.$t("evaluations.newEvaluations.sureDeleteRubric"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_NEW_RUBRIC_INSTRUMENT, this.rubric.id)
            .then(() => {
              toast(
                this.$t("evaluations.newEvaluations.rubricDeleted"),
                "success"
              );
            });
        }
      });
    },
  },
  watch: {
    selectedUsers(value) {
      if (value.length == 1) {
        this.coevaluator_id = value[0];
      }
    },
    coevaluator_id() {
      if (
        this.currentUserId != null &&
        (this.evaluatee_view || this.evaluator_view)
      ) {
        this.$store.dispatch(names.FETCH_EVALUATEE_RUBRICS, {
          evaluatee_id: this.currentUserId,
          test_id: this.test.id,
        });
        this.$store
          .dispatch(names.FETCH_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVELS, {
            evaluatee_id: this.currentUserId,
            test_id: this.test.id,
          })
          .then((response) => {
            const eva_rub_cri_per_lev_ids = response.map((x) => x.id);
            if (eva_rub_cri_per_lev_ids.length > 0)
              this.$store.dispatch(
                names.FETCH_EVALUATEE_RUBRIC_CRITERIA_PERFORMANCE_LEVEL_EVALUATORS,
                {
                  evaluatee_rubric_criteria_performance_levels_ids:
                    eva_rub_cri_per_lev_ids,
                }
              );
          });
      }
    },
  },
  mounted() {
    if (
      (this.evaluatee_view || this.evaluator_view) &&
      this.evaluative_agent &&
      this.user_id &&
      (["duoc_autoevaluacion_evaluative_agent"].includes(
        this.evaluative_agent.internal_use_id
      ) ||
        this.$equals(this.evaluative_agent.name, "Autoevaluación"))
    )
      this.coevaluator_id = this.currentCoevaluatorId;
    if (
      (this.evaluatee_view || this.evaluator_view) &&
      this.evaluative_agent &&
      this.user_id &&
      (["duoc_coevaluacion_evaluative_agent"].includes(
        this.evaluative_agent.internal_use_id
      ) ||
        this.$equals(this.evaluative_agent.name, "Coevaluación"))
    ) {
      if (
        this.evaluatee_view &&
        this.is_running_test &&
        !this.finished_test &&
        this.evaluateeRubric &&
        this.evaluateeRubric.coevaluators.length == 1
      )
        this.coevaluator_id = this.evaluateeRubric.coevaluators[0];
      else if (
        this.evaluateeRubric &&
        (this.evaluator_view ||
          (this.evaluatee_view &&
            this.finished_test &&
            this.evaluateeRubric.coevaluating.length == 1))
      )
        this.coevaluator_id = this.evaluateeRubric.coevaluating[0];
    }
  },
  created() {
    if (this.filter_rubric_instance == null) {
      this.hide_dimension = this.$store.getters.getLocalVariable(
        this.$options.name,
        "hide_dimension"
      );
      this.hide_number = this.$store.getters.getLocalVariable(
        this.$options.name,
        "hide_number"
      );
      this.hide_weighing = this.$store.getters.getLocalVariable(
        this.$options.name,
        "hide_weighing"
      );
      this.hide_evaluation_criteria = this.$store.getters.getLocalVariable(
        this.$options.name,
        "hide_evaluation_criteria"
      );
    }
    // if (
    //   ((this.requests_within_the_component &&
    //     !this.evaluatee_view &&
    //     !this.evaluator_view) ||
    //     this.evaluatee_view ||
    //     this.evaluator_view) &&
    //   !this.no_requests_in_view
    // ) {
    //   this.$store.dispatch(
    //     names.FETCH_NEW_RUBRIC_INSTRUMENTS,
    //     this.instrument_id
    //   );
    // }
  },
};
</script>
<style scoped src="@/utils/rich_text_editor.css"></style>
<style scoped>
.col-popover-1 {
  z-index: 1010 !important;
}
.feedback-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  max-height: 10em;
  overflow-y: auto;
  padding: 0.25rem 1.2rem;
  line-height: 1.5;
}
.feedback-description >>> p {
  margin-bottom: 0.7rem !important;
}
.col-display-1 {
  min-width: 154px;
  margin-left: 2em;
  background-color: var(--kl-primary-button-color) !important;
  color: #fff;
}
.col-display-1:hover {
  background-color: var(--kl-primary-button-hover-color) !important;
  transition: all 0.3s;
}
.weighing-red {
  color: red;
}
.vertical-align-cell {
  vertical-align: middle !important;
}
.td-rubric-descriptor-cell {
  vertical-align: top;
  /* min-width: 120px; */
}
.sentence-cell >>> p {
  padding-left: 0;
  margin-left: 0;
}
.unselectable-text {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.container-sentence {
  display: flex;
  flex-wrap: wrap;
}
.contailer-il-rubric {
  max-height: 250px !important;
  overflow-y: auto !important;
}
.container-dimension {
  max-height: 250px !important;
  overflow-y: auto !important;
}
::-webkit-scrollbar {
  width: 4px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 8px;
}

::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.text-cell-sencente {
  flex: 1;
  overflow-wrap: break-word; /* Asegura que las palabras se rompan para ajustarse al contenedor */
  word-break: break-word; /* Alternativa para asegurar el ajuste de palabras en navegadores más antiguos */
}
.icon-edit {
  color: var(--kl-primary-button-color);
}
.icon-trash {
  color: red;
}
.td-rubric-descriptor-cell {
  max-width: 100px;
}
.title-rubric {
  font-size: 20pt;
}
.description-rubric {
  padding: 7px 0 7px 5px;
}
.container-buttons {
  display: flex;
  justify-content: left;
}
.container-buttons-dimension {
  display: flex;
  flex-direction: column;
}
.action-button {
  border: none;
  width: 25px;
  height: 25px;
  margin-inline: 3px;
  border-radius: 5px;
  transition: 0.3s all;
}
.action-button-delete {
  border: none;
  color: white;
  padding: 0;
}
.action-button-delete-dimension {
  color: black;
  padding: 0 3px 0 0;
  border: none;
}
table {
  width: 100%;
  font-size: var(--secondary-font-size);
}
td,
th {
  border: 1px solid var(--kl-table-border);
}
th {
  font-size: var(--secondary-font-size);
  font-weight: bold;
  background-color: var(--kl-color-accent-medium);
  color: white;
}
tfoot {
  background-color: var(--kl-color-accent-medium);
  color: white;
  font-weight: bold;
}
span >>> .add-button {
  color: white !important;
}
@media only screen and (min-width: 701px) and (max-width: 1200px) {
  .rubric-achievement-overflow {
    overflow-x: auto;
  }
  .container-sentence {
    display: block;
    text-align: left;
  }
  .table-rubric {
    overflow-x: auto;
  }
  .sentence-cell {
    max-height: 500px;
    overflow: auto;
  }
}
@media only screen and (max-width: 700px) {
  .rubric-achievement-overflow {
    overflow-x: auto;
  }
}
@media only screen and (max-width: 620px) {
  .rubric-achievement-overflow {
    overflow-x: auto;
  }
}
@media print {
  .sentence-cell {
    overflow: hidden !important;
  }
  .contailer-il-rubric,
  .container-dimension {
    overflow: hidden !important;
    max-height: 100% !important;
  }
}
</style>

